/**
 * Get the list of networks that initialized successfully
 * @param {array} initPromises array of init promise responses
 * @return {number} successfulNetworksCount that initialized successfully
 */
const getSuccessfulNetworksCount = initPromises => {
  if (Array.isArray(initPromises) && initPromises.length > 0) {
    const successfulNetworksCount =
      initPromises.filter(network => network && network.isError === false)?.length ?? 0;
    return successfulNetworksCount;
  }
  return 0;
};

export default getSuccessfulNetworksCount;
